import { createListenerMiddleware } from '@reduxjs/toolkit';

import { UserInfoFetcher } from '../../api/fetchers/userInfo/fetcher';
import { CorePredicator } from '../CorePredicator';
import type { CoreRootState } from '../CoreStore';
import { selectShouldMergeBonusBalance } from '../slices/config/rawSelectors';

export const userInfoMiddleware = createListenerMiddleware<CoreRootState>();

/**
 * Note: Regarding using CorePredicator.createListener here.
 * Handling boolean condition in CorePredicator here is far more verbose, reverting back to the traditional listener.
 */
const unsubscribeUserInfoOptionsListener = userInfoMiddleware.startListening({
  predicate: CorePredicator.all((state) => [selectShouldMergeBonusBalance(state) !== undefined]),
  effect: (_, { getState }) => {
    const shouldMergeBonusBalance = selectShouldMergeBonusBalance(getState());
    UserInfoFetcher.setOptions({ totalBalance: shouldMergeBonusBalance as boolean });
    unsubscribeUserInfoOptionsListener();
  },
});
